/** @format */
import SingleShipmentJoinButton from 'frontier/cart/components/shipping/single_shipment_join_button';
import {createListTargetUpdate, parseCheckboxValue} from 'frontier/components/form/handle_change';
import SingleShipmentAddresses from 'frontier/cart/components/shipping/single_shipment_address';
import SingleShipmentMethods from 'frontier/cart/components/shipping/single_shipment_methods';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';
import {Banner, Checkbox, IconButton, Input, Popover} from '@sttark/design-system';
import SingleOrderSplitShipmentButton from './single_order_split_shipment_button';
import {prettyProductLabel} from 'frontier/ds/quoter/functions/format';
import {useSaveInput} from 'frontier/components/form/use_save_input';
import {PRODUCT_TYPE_GRAPHIC_DESIGN, SHIPPING_PROVIDER_NONE} from 'frontier-constants';
import {ShowEstimatedArrival} from './show_estimated_arrival';
import {useSave} from '../../../components/form/use_save';
import {If, IfElse} from 'frontier-utilities';
import React, {useContext} from 'react';

// styles
import './single_shipment.sass';

export default function SingleShipment({relatedShipmentIndex, toShipmentId, shipment, index}) {
    const ctx = useContext(CartCheckoutContext);

    const {
        saveInput: saveIsShippingBlind,
        isSaving: isShippingBlindSaving,
        error: isShippingBlindError
    } = useSaveInput(`/account/shipments/edit/${shipment.id}`, 'is_shipping_blind', 750);

    const {
        saveInput: saveShippingAccountNumberFedex,
        isSaving: isShippingAccountNumberFedexSaving,
        error: isShippingAccountNumberFedexError
    } = useSaveInput(
        `/account/shipments/edit/${shipment.id}`,
        'shipping_account_number_fedex',
        750
    );

    const {
        isSaving: isCustomerAccountSaving,
        error: customerAccountError,
        save: saveCustomerAccount
    } = useSave(`/account/shipments/edit/${shipment.id}`, 750);

    const saveCustomerAccountNumber = async value => {
        const index = ctx.shipments.findIndex(item => item.id === shipment.id);
        const updateTarget = {
            [index]: {
                use_customer_account_number: {$set: value?.length > 0},
                customer_account_number: {$set: value}
            }
        };
        ctx.onUpdateWithoutSave({
            shipments: updateTarget
        });

        saveCustomerAccount({
            customer_account_number: value,
            use_customer_account_number: value?.length > 0
        });
    };

    // Ensures we always get the latest address data
    const address = ctx.addresses.find(({id}) => id === shipment.address_id) ?? {};

    return (
        <div className="order-container-overview mt-5" style={{zIndex: 1000 / (index + 1)}}>
            {/* shipment count */}
            <div className="d-flex align-items-center justify-content-between order-container-overview_shipment-count mb-2">
                <p className="font-body-md m-0 tw-p-0">Includes order(s):</p>
                <div className="m-0 tw-p-0 d-flex align-items-center justify-content-start">
                    <p className="m-0"> Shipment </p>
                    <h5 className="ps-2 font-body-md m-0">
                        {index + 1} of {ctx.shipments.length}
                    </h5>
                </div>
            </div>

            {/* list of shipments included in this order*/}
            <div className="order-container-overview_shipments-included">
                {shipment.orders_shipments.map(({order}) => {
                    let itemLabel =
                        order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN
                            ? order.product_type_label
                            : order.size_description;

                    const label = prettyProductLabel(itemLabel, order.product_type_id);

                    return (
                        <div key={order.id} className="shipments-included_shipment">
                            <div className="d-flex align-items-center justify-content-start">
                                <h5 className="me-3 mb-0">{label}</h5>
                                <u className="color-accent-primary">
                                    {shipment.orders_shipments.length > 1 && (
                                        <SingleOrderSplitShipmentButton
                                            orderId={order.id}
                                            shipmentId={shipment.id}
                                        />
                                    )}
                                </u>
                            </div>
                            <p>
                                ({order.substrate_label}, {order.laminate_label})
                            </p>
                        </div>
                    );
                })}
            </div>
            <SingleShipmentAddresses shipmentId={shipment.id} addressId={shipment.address_id} />

            {/* Checkboxes ✅*/}
            <div className="d-flex align-items-center justify-content-between w-100 checkout-input-section-02hg">
                {/* checkbox; - sets shipping address_id as billing address_id */}
                <div className="d-flex align-items-center justify-content-start">
                    <label className="d-flex align-items-center justify-content-start m-0 checkbox-label">
                        <Checkbox
                            onChange={() => {
                                if (ctx.cart.billing_address_id === shipment.address_id) {
                                    ctx.onChange({cart: {billing_address_id: {$set: null}}});
                                } else {
                                    ctx.onChange({
                                        cart: {billing_address_id: {$set: shipment.address_id}}
                                    });
                                }
                            }}
                            label={'Use as billing address'}
                            name="use_as_billing_address"
                            value={ctx.cart.billing_address_id === shipment.address_id}
                            bold
                            checked={ctx.cart.billing_address_id === shipment.address_id}
                            small
                        />
                    </label>
                </div>

                {/* checkbox; - Removes branding*/}
                <div className="d-flex align-items-center justify-content-start">
                    <div className="d-flex align-items-center justify-content-start m-0 checkbox-label">
                        <Checkbox
                            onChange={value => {
                                const newValue = parseCheckboxValue(value);
                                ctx.onUpdateWithoutSave({
                                    shipments: createListTargetUpdate(
                                        ctx.shipments,
                                        shipment.id,
                                        'is_shipping_blind',
                                        newValue
                                    )
                                });
                                saveIsShippingBlind(newValue);
                            }}
                            value={shipment.is_shipping_blind}
                            //bold={shipment.is_shipping_blind}
                            bold
                            checked={shipment.is_shipping_blind}
                            name="is_shipping_blind"
                            label="Blind Ship"
                            error={false}
                            small
                        />
                    </div>
                    {/* popover for the checkbox that removes branding 👆*/}
                    <div className="position-relative">
                        <div
                            className=" tw-pb-1"
                            onClick={() => {
                                setOpenPopover(!openPopOver);

                                if (openPopOver) {
                                    setTimeout(
                                        () => window.addEventListener('click', togglePopover),
                                        500
                                    );
                                }
                            }}>
                            <Popover
                                title="Blind Shipping"
                                content={<p>Removes Sttark branding from packaging.</p>}>
                                <div className="mb-2">
                                    <IconButton small secondary icon="info" />
                                </div>
                            </Popover>
                        </div>
                    </div>
                </div>
            </div>

            {/* allows user to select shipping 🚀*/}
            <If condition={shipment.address_id}>
                <SingleShipmentMethods
                    shippingMethodProvider={shipment.shipping_method_provider}
                    shippingMethodCode={shipment.shipping_method_code}
                    isSaturdayDelivery={shipment.is_saturday_delivery}
                    addressId={shipment.address_id}
                    shipmentId={shipment.id}
                />
            </If>

            {/* allows user's to input their own customer UPS number */}
            <If
                condition={
                    shipment.address_id &&
                    !(
                        (shipment.shipping_method_provider === SHIPPING_PROVIDER_NONE ||
                            shipment.shipping_method_provider === 'none') &&
                        shipment.shipping_method_code === '01'
                    )
                }>
                <div>
                    <div className="container_shipping-address">
                        <IfElse condition={shipment.use_customer_account_number > 0}>
                            <h6 className="color-accent-primary m-0">
                                <i className="fa fa-check me-2" />
                                UPS customer number
                            </h6>
                            <p>
                                Use my shipping account #{' '}
                                <span className="color-structure-darker">(optional)</span>
                            </p>
                        </IfElse>
                    </div>

                    <Input
                        value={shipment.customer_account_number || ''}
                        onChange={saveCustomerAccountNumber}
                        label="UPS customer number"
                    />
                    {/* de activate it for now. If customers are confued about when their data is being saved, uncomment again*/}
                    {/*<If condition={isCustomerAccountSaving}>*/}
                    {/*    <p className="color-accent-primary"><i className="fa fa-spinner fa-spin"/>Saving...</p>*/}
                    {/*</If>*/}
                </div>
            </If>

            <If condition={shipment.quoted_delivery_date}>
                <ShowEstimatedArrival shipment={shipment} />
            </If>

            <If condition={relatedShipmentIndex > -1 && relatedShipmentIndex < index}>
                <Banner className="combine-shipments-banner">
                    <SingleShipmentJoinButton
                        fromShipmentId={shipment.id}
                        toShipmentId={toShipmentId}
                        relatedShipmentIndex={relatedShipmentIndex}
                    />
                </Banner>
            </If>
        </div>
    );
}
